import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import Image from 'next/image'
import { useState } from 'react'
import { useGoogleConnectedStatus } from './hooks/connect-gmail'
import { DealSyncSideBarModalConnect } from './SbModalConnect'
import styles from './styles/deal-sync-sidebar-card.module.scss'

export const DealSyncSideBarCard = () => {
  const { data, isLoading } = useGoogleConnectedStatus()
  const isGoogleConnected = data?.gmailConnected
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClickOnGoogleConnect = () => {
    setIsModalOpen(true)
  }

  const showCard = !isGoogleConnected && !isLoading

  return (
    <>
      <DealSyncSideBarModalConnect
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />

      {showCard && (
        <div className="full-w">
          <div className={styles.card}>
            <div className={styles.header}>
              <div
                className="relative"
                style={{
                  aspectRatio: '32 / 6',
                  margin: '0 auto',
                  height: '30px',
                }}
              >
                <Image
                  src="/assets/creatorland-deal-sync-logo-2.png"
                  alt="Logo Sync"
                  style={{
                    objectFit: 'contain',
                    width: '100%',
                  }}
                  layout="fill"
                />
              </div>
            </div>
            <div className="p-16 pt-10">
              <Title variation="xSmall" className="mb-4" sizeClass="text-14">
                Unlock Your VIP Network
              </Title>
              <Text variation="xSmall" sizeClass="text-13">
                Rediscover past collaborators, identify decision makers, and
                build your professional network with the click of a button!
              </Text>

              <div className="flex full-w justify-center mt-12">
                <button
                  onClick={handleClickOnGoogleConnect}
                  className="bg-white full-w rounded-50 cursor-pointer hover__bg-secondary  flex items-center justify-center gap-8 py-5 px-6 pl-18 border border-solid border-primary border-1"
                >
                  <Image
                    src="/assets/images/google-icon.svg"
                    alt="Google"
                    width={24}
                    height={24}
                  />
                  <span className="font-bold text-13">
                    Continue with Google
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
